/**
 * @generated SignedSource<<ea1838bb7db599ba7e867b052706aa13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsMapLayout_map",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModule",
      "kind": "LinkedField",
      "name": "participativeModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ParticipativeModuleAuthorizations",
          "kind": "LinkedField",
          "name": "authorizations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "contributionsSubmissionAuthorized",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MapDroppableZone",
      "kind": "LinkedField",
      "name": "contributionZone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasCoordinates",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapDroppableZone_droppableZone"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapDroppableZoneWithoutLimit_droppableZone"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapWithSidebarLayout_map"
    }
  ],
  "type": "ContributionsMap",
  "abstractKey": null
};

node.hash = "cffde49a2360cb3885e7dbeeffcc4ede";

module.exports = node;
